import styled from "styled-components";
export const FilterCalendar = styled.div`
  height: fit-content;
  overflow: hidden auto;
  background: #f6f6f6;
  padding: 6px 19px;
  height: 92%;

  div:nth-child(1) {
    font-size: 16px;
    color: rgb(143, 155, 179);
  }
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.button.primary};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;
export const FilterTitle = styled.div`
  background-color: #cccaca;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 10px;
  font-weight: 700;
  font-size: 1rem;
`;
